import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import AutoComplete from '../../../commonComponents/formComponents/AutoComplete'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import { getArtNumByHTSCode } from '../../api/getNLForm'
import { TranslateContext } from '../TranslateContext'

const ArticalNumber = ({ invoiceId, lineItemIndex, id, updateData, saveData }) => {
    const htsCode = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.commodity) || ''
    const articleNum = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.articleNum) || ''
    const [list, setList] = useState([])
    const translate = React.useContext(TranslateContext).translate
    const changeHandler = async (value) => {
        const response = await getArtNumByHTSCode(htsCode)
        const list = response?.data?.eventMessage?.dualUseCode?.map((itm) => ({ title: itm })) || []
        setList(list)
    }
    useEffect(() => { setList([]) }, [htsCode])

    return (
        <AutoComplete
            minCharacters={1}
            labelIcon={<PopUpIcon
                icon="info circle"
                popupText={
                    "enter at least 1 characters"
                }
            />}
            id={id}
            label={translate('ART_NMBR', { ns: ['default', 'lineItem'] })}
            disabled={!htsCode}
            onSearchChange={changeHandler}
            dataSource={list}
            selectedValue={articleNum}
            onSelect={(value) => {
                updateData({ articleNum: value?.title })
                saveData({ articleNum: value?.title || " " })
            }}
            onBlur={() => {
                saveData({ articleNum: articleNum || " " })
            }}
        />
    )
}

export default ArticalNumber